import { useEffect } from "react";
import useDropdownSelector from "../../../hooks/useDropdownSelector";

const useDropdownFilter = ({ parameter, onFilterChange }) => {
  const options = parameter?.values?.map((value) => ({
    id: value,
    label: value,
  }));

  const dropdown = useDropdownSelector({
    defaultValue: { id: null, label: "-" },
    options,
  });

  // Update dropdown options when parameter values change
  useEffect(() => {
    dropdown.reset(options);
    // eslint-disable-next-line
  }, [JSON.stringify(parameter?.values)]);

  useEffect(() => {
    onFilterChange({ id: parameter.id, value: dropdown?.value?.id });
    // eslint-disable-next-line
  }, [dropdown?.value?.id]);

  return { dropdown };
};

export default useDropdownFilter;
